var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "account-container enter-container"
  }, [_c('router-link', {
    staticClass: "logo",
    attrs: {
      "to": "/"
    }
  }), _c('div', {
    staticClass: "enter-container-wrapper"
  }, [_vm.step === 1 ? [_vm.isMail ? _c('div', {
    staticClass: "enter-caption"
  }, [_vm._v("Вход в почту")]) : _c('div', {
    staticClass: "enter-caption"
  }, [_vm._v("Вход в кабинет / регистрация")]), _c('div', {
    attrs: {
      "id": "payment-form"
    }
  }), _c('form', {
    staticClass: "enter-form",
    attrs: {
      "autocomplete": "_off"
    }
  }, [_c('div', {
    staticClass: "input-containers",
    class: {
      'input-containers-error': _vm.error,
      'input-containers-error-agreement': _vm.error && _vm.error.type === 'agreement'
    }
  }, [_c('label', {
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Введите номер телефона")]), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.phone,
      expression: "phone"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: '+7 ### ### ## ##',
      expression: "'+7 ### ### ## ##'"
    }],
    staticClass: "text-input",
    class: {
      'text-input-error': _vm.error.message
    },
    attrs: {
      "type": "tel",
      "placeholder": "+7 999 123 45 67",
      "id": "phone"
    },
    domProps: {
      "value": _vm.phone
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value;
      }
    }
  })]), _c('div', {
    staticClass: "input-group button-group"
  }, [_c('input', {
    staticClass: "button blue",
    attrs: {
      "type": "submit"
    },
    domProps: {
      "value": _vm.error.message || 'Продолжить'
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.handleSubmit($event);
      }
    }
  })])])]), _vm.isMail ? _c('div', {
    staticClass: "_bottom"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push('/');
      }
    }
  }, [_vm._v("Вернуться на главную")])]) : _c('div', {
    staticClass: "_bottom"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push('/');
      }
    }
  }, [_vm._v("Вернуться назад")])])] : _vm._e(), _vm.step === 2 ? [_c('div', {
    staticClass: "enter-caption"
  }, [_vm._v("Регистрация")]), _c('div', {
    staticClass: "enter-description"
  }, [_vm._v(" Данный номер телефона еще не зарегистрирован, задайте пароль для входа. ")]), _c('form', {
    staticClass: "enter-form",
    attrs: {
      "method": "post",
      "autocomplete": "off"
    }
  }, [_c('div', {
    staticClass: "input-containers",
    class: {
      'input-containers-error': _vm.error
    }
  }, [_c('div', {
    staticClass: "input-group",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "relative mt-30px"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.password,
      expression: "password"
    }],
    staticClass: "text-input",
    class: {
      'text-input-error': _vm.error.message
    },
    attrs: {
      "type": "password",
      "placeholder": "Пароль"
    },
    domProps: {
      "value": _vm.password
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value;
      }
    }
  })]), _c('div', {
    staticClass: "relative mt-30px"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.passwordConfirm,
      expression: "passwordConfirm"
    }],
    staticClass: "text-input",
    class: {
      'text-input-error': _vm.error.message
    },
    attrs: {
      "type": "password",
      "placeholder": "Пароль еще раз"
    },
    domProps: {
      "value": _vm.passwordConfirm
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.passwordConfirm = $event.target.value;
      }
    }
  })])]), _c('div', {
    staticClass: "input-group button-group"
  }, [_c('input', {
    staticClass: "button blue",
    attrs: {
      "type": "submit"
    },
    domProps: {
      "value": _vm.error.message || 'Зарегистрироваться'
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.handleSubmit($event);
      }
    }
  })])])]), _c('div', {
    staticClass: "_bottom"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        _vm.step = 1;
      }
    }
  }, [_vm._v("Назад")])])] : _vm._e(), _vm.step === 3 ? [_c('div', {
    staticClass: "enter-caption"
  }, [_vm._v("Вход")]), _c('div', {
    staticClass: "enter-description"
  }, [_vm._v(" Данный номер телефона уже зарегистрирован, введите пароль для входа. ")]), _c('form', {
    staticClass: "enter-form",
    attrs: {
      "method": "post",
      "autocomplete": "off"
    }
  }, [_c('div', {
    staticClass: "input-containers",
    class: {
      'input-containers-error': _vm.error
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "relative mt-30px"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.password,
      expression: "password"
    }],
    staticClass: "text-input",
    class: {
      'text-input-error': _vm.error.message
    },
    attrs: {
      "type": "password",
      "placeholder": "Пароль"
    },
    domProps: {
      "value": _vm.password
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value;
      }
    }
  })])]), _c('div', {
    staticClass: "input-group button-group"
  }, [_c('input', {
    staticClass: "button blue",
    attrs: {
      "type": "submit"
    },
    domProps: {
      "value": _vm.error.message || 'Войти'
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.handleSubmit($event);
      }
    }
  })])])]), _c('div', {
    staticClass: "_bottom"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        _vm.step = 4;
      }
    }
  }, [_vm._v("Забыл пароль")])]), _c('div', {
    staticClass: "_bottom"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        _vm.step = 1;
      }
    }
  }, [_vm._v("Назад")])])] : _vm._e(), _vm.step === 4 ? [_c('div', {
    staticClass: "enter-caption"
  }, [_vm._v("Восстановление доступа")]), _c('div', {
    staticClass: "enter-description"
  }, [_vm._v(" Чтобы создать новый пароль введите код из смс ")]), _c('form', {
    staticClass: "enter-form",
    attrs: {
      "method": "post",
      "autocomplete": "off"
    }
  }, [_c('div', {
    staticClass: "input-containers",
    class: {
      'input-containers-error': _vm.error
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "relative mt-30px"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.code,
      expression: "code"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: '####',
      expression: "'####'"
    }],
    key: "code",
    staticClass: "text-input",
    class: {
      'text-input-error': _vm.error.message
    },
    attrs: {
      "type": "text",
      "placeholder": "Код"
    },
    domProps: {
      "value": _vm.code
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value;
      }
    }
  })])]), _c('div', {
    staticClass: "input-group button-group"
  }, [_c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.code.length !== 4,
      expression: "code.length !== 4"
    }],
    staticClass: "button blue",
    attrs: {
      "type": "submit",
      "disabled": _vm.codeSubmitDisabled
    },
    domProps: {
      "value": _vm.codeSubmitButton
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.sendCode($event);
      }
    }
  }), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.code.length === 4,
      expression: "code.length === 4"
    }],
    staticClass: "button blue",
    attrs: {
      "type": "submit"
    },
    domProps: {
      "value": _vm.error.message || 'Продолжить'
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.handleSubmit($event);
      }
    }
  })])])])] : _vm._e(), _vm.step === 5 ? [_c('div', {
    staticClass: "enter-caption"
  }, [_vm._v("Восстановление доступа")]), _c('div', {
    staticClass: "enter-description"
  }, [_vm._v(" Задайте новый пароль для входа ")]), _c('form', {
    staticClass: "enter-form",
    attrs: {
      "method": "post",
      "autocomplete": "off"
    }
  }, [_c('div', {
    staticClass: "input-containers",
    class: {
      'input-containers-error': _vm.error
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "relative mt-30px"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.password,
      expression: "password"
    }],
    key: "password",
    staticClass: "text-input",
    class: {
      'text-input-error': _vm.error.message
    },
    attrs: {
      "type": "password",
      "placeholder": "Пароль"
    },
    domProps: {
      "value": _vm.password
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value;
      }
    }
  })])]), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "relative mt-30px"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.passwordConfirm,
      expression: "passwordConfirm"
    }],
    key: "passwordConfirm",
    staticClass: "text-input",
    class: {
      'text-input-error': _vm.error.message
    },
    attrs: {
      "type": "password",
      "placeholder": "Пароль еще раз"
    },
    domProps: {
      "value": _vm.passwordConfirm
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.passwordConfirm = $event.target.value;
      }
    }
  })])]), _c('div', {
    staticClass: "input-group button-group"
  }, [_c('input', {
    staticClass: "button blue",
    attrs: {
      "type": "submit"
    },
    domProps: {
      "value": _vm.error.message || 'Войти'
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.handleSubmit($event);
      }
    }
  })])])])] : _vm._e()], 2), !_vm.isMail ? _c('footer', [_vm.step === 1 ? _c('div', {
    staticClass: "agreement-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.agreement,
      expression: "agreement"
    }],
    attrs: {
      "type": "checkbox",
      "id": "agreement"
    },
    domProps: {
      "checked": Array.isArray(_vm.agreement) ? _vm._i(_vm.agreement, null) > -1 : _vm.agreement
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.agreement,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.agreement = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.agreement = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.agreement = $$c;
        }
      }
    }
  }), _vm._m(0)]) : _vm._e(), false ? _c('div', [_vm._v(" Нажимая на кнопку “Продолжить” и подтверждая номер телефона кодом из"), _c('br', {
    staticClass: "__hide-desktop"
  }), _vm._v(" SMS, Вы принимаете "), _c('a', {
    attrs: {
      "href": "/oferta.pdf",
      "target": "_blank"
    }
  }, [_vm._v("Условия использования сервиса “Финсайт”")]), _vm._v(", даете согласие"), _c('br', {
    staticClass: "__hide-desktop"
  }), _vm._v(" на обработку своих персональных данных и соглашаетесь с "), _vm._m(1), _vm._v(". Стоимость услуги 12 рублей в день, оплата со счета"), _c('br', {
    staticClass: "__hide-desktop"
  }), _vm._v(" телефона. Первые 3 дня предоставляются бесплатно. ")]) : _vm._e()]) : _vm._e()], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "agreement",
    attrs: {
      "for": "agreement"
    }
  }, [_vm._v(" Нажимая на кнопку “Продолжить” Вы принимаете "), _c('a', {
    attrs: {
      "href": "/oferta.pdf",
      "target": "_blank"
    }
  }, [_vm._v("Условия использования сервиса “Финсайт”")]), _vm._v(", даете "), _c('a', {
    attrs: {
      "href": "/oferta.pdf",
      "target": "_blank"
    }
  }, [_vm._v("согласие на обработку своих персональных данных")]), _vm._v(" и соглашаетесь с условиями "), _c('a', {
    attrs: {
      "href": "/oferta.pdf",
      "target": "_blank"
    }
  }, [_vm._v("политики конфиденциальности")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('a', {
    attrs: {
      "href": "/privacy"
    }
  }, [_vm._v("условиями"), _c('br', {
    staticClass: "__hide-mobile"
  }), _vm._v(" политики"), _c('br', {
    staticClass: "__hide-desktop"
  }), _vm._v(" конфиденциальности")]);
}]

export { render, staticRenderFns }